@if (isWarningVisible()) {
<div class="session-warning-overlay">
  <div class="session-warning-dialog">
    <div class="warning-header">
      <h3 class="text-xl">Session Timeout Warning</h3>
    </div>
    
    <div class="warning-content">
      <p>Your session will expire in <strong class="text-lg">{{ formatTimeRemaining() }}</strong>.</p>
      <p>Click "Extend Session" to continue working, or you will be automatically logged out when the timer reaches zero.</p>
    </div>
    
    <div class="warning-actions">
      <button 
        tuiButton 
        appearance="secondary" 
        (click)="extendSession()">
        Extend Session
      </button>
      <button 
        tuiButton 
        appearance="primary" 
        (click)="logout()">
        Logout Now
      </button>
    </div>
  </div>
</div>
}
